export default {"src":"/_next/static/image/public/images/icons1/6.f0de03910bba85a3e6e56400e41f705f.svg","height":22,"width":23};